import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="section contact">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">
          We're here to help with all your shipping and logistics needs
        </p>
        
        <div className="contact-wrapper">
          <div className="contact-cards">
            <div className="contact-card">
              <h3>Email Us</h3>
              <p className="contact-note">For general enquiries and information</p>
              <a href="mailto:info@cnterminalghana.com"><Mail size={16} /> info@cnterminalghana.com</a>
              <a href="mailto:enquiries@cnterminalghana.com"><Mail size={16} /> enquiries@cnterminalghana.com</a>
            </div>
            
            <div className="contact-card">
              <h3>Call Us</h3>
              <p className="contact-note">Available during business hours</p>
              <a href="tel:+233553799811"><Phone size={16} /> +233 553 799 811</a>
              <a href="tel:+233506580292"><Phone size={16} /> +233 506 580 292</a>
              <a href="tel:+233555552645"><Phone size={16} /> +233 555 552 645</a>
            </div>
            
            <div className="contact-card">
              <h3>Visit Us</h3>
              <p className="contact-note">Our office location</p>
              <div className="address">
                <MapPin size={16} className="address-icon" />
                <div className="address-content">
                  <p className="address-line"><strong>CN Terminal Company Limited</strong></p>
                  <p className="address-line">Salifu Dagati Extension</p>
                  <p className="address-line">Tema Community Two</p>
                  <p className="address-line">Opposite Tema Police Station</p>
                  <p className="address-line">P.O. BOX TN 161</p>
                  <p className="address-line">Teshie-Nungua, Accra, Ghana</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
